module.exports = __webpack_public_path__ + "img/dy.09f6f8a6.png";